import React from 'react'
import {Row, Col} from 'react-bootstrap'
import { withTranslation } from 'react-i18next'

function PerfilPacienteInfo({t, paciente}) {
    return (<div className='body'>
        <p className='section-title'>{ t('paciente_informacion') }</p>
        <p className='nombre-paciente'>{ `${paciente?.name} ${paciente?.middleName ?? ''} ${paciente?.lastName} ${paciente?.seccondSurname ?? ''}` }</p>
        <Row className='paciente-seccion-info'>
            <Col>
                <p className='section-info info-resaltado'>{t('sexo')}:&nbsp;</p>
                <p className='section-info info'>{paciente?.gender === 'Male' ? t('Masculino') : t('Femenino')}</p>
            </Col>
            <Col>
                <p className='section-info info-resaltado'>{t('Tiposangre')}:&nbsp;</p>
                <p className='section-info info'>{paciente?.bloodType}</p>
            </Col>
        </Row>
        <Row className='paciente-seccion-info'>
            <Col>
                <p className='section-info info-resaltado'>{t('Telefono')}:&nbsp;</p>
                <p className='section-info info'>{paciente?.phone}</p>
            </Col>
            <Col>
                <p className='section-info info-resaltado'>{t('Correoelectronico')}:&nbsp;</p>
                <p className='section-info info'>{paciente?.email}</p>
            </Col>
        </Row>
    </div>)
}

export default withTranslation()(PerfilPacienteInfo)